<template>
	<div class="empty-box">
		<img src="@/static/image/empty-box.png" alt="" srcset="" />
		<div class="txt">{{title}}</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {

			}
		},
		props: {
			title: {
				type: String,
				default: '',
			},
		}
	}
</script>

<style>
	.empty-box {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		padding-top: 50px;
		padding-bottom: 50px;
		
	}

	.empty-box image {
		width: 414px;
		height: 240px;
		margin-bottom: 20px;
	}

	.empty-box .txt {
		font-size: 16px;
		color: #999;
	}
</style>